import { render, staticRenderFns } from "./VendorEdit_Details.vue?vue&type=template&id=25ec4753&"
import script from "./VendorEdit_Details.vue?vue&type=script&lang=js&"
export * from "./VendorEdit_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports